import { gql } from '__generated__'

/**
 * Makes one of the signed-in user's linked wallets primary (backend PR #189).
 * The answer carries the wallets, so the normalized `User` in the cache — and
 * `me` with it — updates without a refetch.
 */
export const SET_PRIMARY_WALLET = gql(`
  mutation setPrimaryWallet($walletAddress: String!) {
    setPrimaryWallet(walletAddress: $walletAddress) {
      id
      primaryWalletAddress
      wallets {
        id
        address
        isPrimary
        createdAt
      }
    }
  }
`)
